import { initTransferSearch, fetchTransferSearchResults } from "../../api";
import _ from "lodash";
import { DateTime } from "luxon";
import { checkPackagePriceSearch, pollPackageTransfersPriceSearch } from ".";
import { PACKAGE_TRF_SEARCH_RESULT_SAVE } from "./types";
import { pkgFailedSearch } from "../search";

export const createTransferPayloads = (state) => {
  const { adults, children } = state.PriceSearchForm;
  const {
    metadata: { source_entity },
  } = state.WebsiteMetadata;
  const api_key = window.btoa(source_entity);

  const payloads = [];

  const destinations = _.get(state.TourDetails, "details.destinations", []);
  const airportPickupDelta = _.get(
    state.TourDetails,
    "details.transfer_preferences.pickupAfterArrival",
    0
  );
  const hotelPickupDelta = _.get(
    state.TourDetails,
    "details.transfer_preferences.pickupBeforeDeparture",
    0
  );
  destinations.foreach((dest, idx) => {
    const { order: dest_order, country_code } = dest;
    var nextDest = _.get(destinations, idx + 1);
    if (!nextDest) {
      nextDest = dest;
    }
    const { order: next_dest_order } = nextDest;

    var acc = _.get(
      state.TourDetails,
      `details.accommodation_data.${dest_order}.0`
    );
    acc = _.pick(acc.metadata, ["geodata", "name", "id", "address"]);

    const arrival_flight_key =
      dest_order.toString() === "1" ? "extremalLeg" : dest_order;

    const departing_flight_key =
      next_dest_order.toString() === "1" ? "extremalLeg" : next_dest_order;

    const arrival_flights = _.get(
      state.TourDetails,
      `details.transportation_data.flights.${arrival_flight_key}`,
      []
    );
    const arrival_flight = (arrival_flights?.[0]?.legs?.[0] ?? []).find(
      (option) => option.selected
    );
    const arrival_airport = _.get(
      _.last(_.get(arrival_flight, "segments", [])),
      "destination_airport"
    );

    const departing_flights = _.get(
      state.TourDetails,
      `details.transportation_data.flights.${departing_flight_key}`,
      []
    );
    const departing_flight = _.get(
      departing_flights,
      `0.${
        next_dest_order === dest_order ? "inbound_options" : "outbound_options"
      }`,
      []
    ).find((option) => option.selected);
    const departing_airport = _.get(
      _.get(departing_flight, "segments.0", []),
      "origin_airport"
    );

    const inbound = DateTime.fromISO(arrival_flight.arrival)
      .plus({
        minutes: airportPickupDelta,
      })
      .setZone("UTC", { keepLocalTime: true });
    const outbound = DateTime.fromISO(departing_flight.departure)
      .minus({
        minutes: hotelPickupDelta,
      })
      .setZone("UTC", { keepLocalTime: true });

    const common = {
      dest_order,
      adults,
      children,
      roundtrip: false,
      api_key,
    };

    payloads.push({
      origin: { ...arrival_airport, country_code },
      destination: { ...acc, country_code },
      inbound: inbound.toISO(),
      type: "airport_to_hotel",
      ...common,
    });

    if (departing_airport.iata === arrival_airport.iata) {
      payloads[0]["roundtrip"] = true;
      payloads[0]["outbound"] = outbound.toISO();
    } else {
      payloads.push({
        origin: { ...acc, country_code },
        destination: { ...departing_airport, country_code },
        inbound: outbound.toISO(),
        type: "hotel_to_airport",
        ...common,
      });
    }
  });

  return payloads;
};

export const transfersSearchInitiator =
  ({ payloads, pkg_session_id, pkg_reference }) =>
  async (dispatch) => {
    const result = await initTransferSearch({
      reference: pkg_reference,
      session_id: pkg_session_id,
      payloads,
    });

    if (result !== null) {
      dispatch(pollPackageTransfersPriceSearch({ reference: pkg_reference }));
    }
  };

export const transferSearchResultsFetcher =
  () => async (dispatch, getState) => {
    const state = getState();
    const transferSessions = _.get(
      state.TourPriceInfo,
      "search_data.search_statuses.transfers",
      []
    );

    for (let idx in transferSessions) {
      const session = transferSessions[idx];
      const { session_id, dest_order } = session;

      const result = await fetchTransferSearchResults({
        session_id,
        params: {
          page_size: 1,
        },
      });
      const transfer = _.get(result, "results.0");

      if (!transfer) {
        dispatch(pkgFailedSearch());
        return;
      }

      transfer["selected"] = true;
      var payload = { dest_order, data: [transfer], status: false };
      if (!_.isEmpty(_.get(transfer, "outbound", {}))) {
        payload["leg_type"] = "inbound_outbound";
      } else if (!_.isEmpty(_.get(transfer, "inbound", {}))) {
        payload["leg_type"] = "inbound";
      } else if (!_.isEmpty(_.get(transfer, "outbound", {}))) {
        payload["leg_type"] = "outbound";
      }

      await dispatch(saveTransferSearchResult(payload));
    }

    dispatch(checkPackagePriceSearch());
  };

const saveTransferSearchResult = ({ dest_order, leg_type, data, status }) => {
  return {
    type: PACKAGE_TRF_SEARCH_RESULT_SAVE,
    dest_order,
    leg_type,
    data,
    status,
  };
};
